(function () {
  'use strict';

  angular.module('unit.payment').factory('UnitPayment', UnitPayment);

  UnitPayment.$inject = ['$resource'];

  function UnitPayment($resource) {
    return $resource(
      '/api/',
      {},
      {
        create: { method: 'POST', url: '/api/payment/create' },
      },
    );
  }
})();
